import React, { useState } from 'react'
import { getWebsiteMaintenanceStatus, getWebsiteMaintenanceMessage } from '../services/Api'

const ClientInfo = ({show, pol, zip, setPol, setZip, handleShowModal, errorMessage, setShowPaymentDisclaimer, showLoadingText}) => {
    const [maintenanceMessage, setMaintenanceMessage] = useState(null);
    
    async function fetchWebsiteMaintainence() {
        var websiteStatusResponse = await getWebsiteMaintenanceStatus();
        var websiteMessageResponse = await getWebsiteMaintenanceMessage();
    
        const status = websiteStatusResponse?.data
        if (status?.Result == "Active" && status?.Pages.includes("CurePayments")) {
            setMaintenanceMessage(websiteMessageResponse?.data?.Result);
            return websiteMessageResponse?.data?.Result;
        } else {
            setMaintenanceMessage(null);
            return null;
        }
    }

    function StartPayment() {
        const maintenancePromise = fetchWebsiteMaintainence();
        maintenancePromise.then((data) => {
            setMaintenanceMessage(data);
            setShowPaymentDisclaimer(data == null);
        });
    }

    return (
        show &&
        <>
            <div className="clientInfoHome" style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center", paddingBottom: "20px", paddingTop: "50px" }}>
                <div>
                    <h1 style={{ textAlign: "center", fontWeight: "500", color: "#046ab0", fontSize: "2.5rem" }}>Online Payment</h1>
                    <p style={{ textAlign: "center", color: "#046ab0", marginBottom: "3.5rem", marginLeft: "15px", marginRight: "15px" }}>Make a payment now with your checking or savings account, credit or debit card, or digital wallet. A convenience fee of $14.95 applies.*
                        <br />
                        Looking for other payment options? <span onClick={() => {handleShowModal()}} style={{ textDecoration: "underline", color: "#007bff", cursor: "pointer" }}>Click here</span>
                    </p>
                    <div className="user-form-container" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-start" }}>
                        <input style={{ color: "#495057", border: "1px solid #ced4da", width: "60%", height: "calc(1.5em + 1rem + 2px)", borderRadius: "0.3rem", textAlign: "center", lineHeight: "1.5rem", padding: "0.5rem 1rem" }} value={pol} onChange={(e) => setPol(e.target.value.toUpperCase().replace(/[^a-zA-Z0-9]/g, ''))} placeholder="Policy Number" maxLength={20}/>
                        <input style={{ color: "#495057", border: "1px solid #ced4da", width: "60%", height: "calc(1.5em + 1rem + 2px)", borderRadius: "0.3rem", textAlign: "center", lineHeight: "1.5rem", padding: "0.5rem 1rem" }} value={zip} onChange={(e) => setZip(e.target.value.replace(/\D/g, ''))} placeholder="Zip Code" maxLength={15} />
                        <label id="ErrorMessage" style={{ color: "red", marginTop: "1em", fontSize: "17px", textAlign: "center", marginLeft: "15px", marginRight: "15px", maxWidth: "720px" }}>{maintenanceMessage || errorMessage}</label>
                        <button onClick={() => { StartPayment(); }} style={{ width: "60%", marginTop: "1em", padding: "0.5rem 1rem", lineHeight: "1.5", borderRadius: "0.3rem", backgroundColor: "#046ab0", borderColor: "#046ab0", color: "#ffffff", textWrap: "nowrap" }}>Start Payment</button>
                    </div>
                </div>
                <p className="fee-disclaimer" style={{position: "inherit", marginTop: "1rem", textAlign: "center", color: "rgb(4, 106, 176)", paddingLeft: "10px", paddingRight: "10px"}}>*A third party convenience fee, charged by One Inc, of $14.95 will be added to your online payment. 
                For more information about One Inc, visit <a href='https://www.oneinc.com/' target='_blank'>oneinc.com</a>.</p>
            </div>
        </>
    )
}

export default ClientInfo